import { Box, styled, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import summitLogo from "./summitLogo.png";

const LogoWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column", // Stack vertically
  justifyContent: "center",
  alignItems: "center",
  width: "220px",
  height: "auto", // let it grow with content
  gap: "0.25rem",
  textDecoration: "none",
}));

function Logo() {
  const theme = useTheme();
  return (
    <Link to="/" style={{ textDecoration: "none" }}>
      <LogoWrapper>
        <img src={summitLogo} alt="Summit" width="150" />
      </LogoWrapper>
    </Link>
  );
}

export default Logo;
